import { RegistrationCardsRequests } from '@/services/registrationCards.requests'
import { ServiceRequests } from '@/services/service.requests'

import camelcaseKeys from 'camelcase-keys'
import Vue from 'vue'

const registrationCardsService = new RegistrationCardsRequests()
const serviceService = new ServiceRequests()

const state = {
  scannedDocument: null,
  verifiedDocumentData: null,
  editedVerifiedDocumentData: null,
  contactData: null,
  tosSignature: null,
  tosFile: null,
}

const getters = {}

const actions = {
  postDocumentScan ({ commit }, { guestId, countryCode, cardType, documentImageFront, documentImageBack = null }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.postDocumentScan(guestId, countryCode, cardType, documentImageFront, documentImageBack).then((documentScan) => {
        resolve(documentScan)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  get ({ commit }, { guestId }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.get(guestId).then((registrationCards) => {
        commit('setRegistrationCards', camelcaseKeys(registrationCards, { deep: true }))
        resolve(registrationCards)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  post ({ state }, { guestId }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.post(guestId, state.editedVerifiedDocumentData).then((documentScan) => {
        resolve(documentScan)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  postContact ({ commit }, { guestId, body }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.postContact(guestId, body).then((contactData) => {
        resolve(contactData)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  postSignature ({ commit }, { guestId, signature, checkboxes }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.postSignature(guestId, signature, checkboxes).then((signature) => {
        resolve(signature)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getTosSignature ({ commit }, { fileId }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.getTosSignature(fileId).then((file) => {
        commit('setTosFile', file)
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getTosFile ({ commit }, { fileId }) {
    return new Promise((resolve, reject) => {
      serviceService.getPublicFile(fileId).then((file) => {
        commit('setTosFile', file)
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getFile ({ commit }, { guestId, fileId }) {
    return new Promise((resolve, reject) => {
      registrationCardsService.getFile(guestId, fileId).then((file) => {
        resolve(file)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  resetRegistrationCardState (state) {
    state.scannedDocument = null
    state.contactData = null
    state.verifiedDocumentData = null
    state.tosSignature = null
  },
  setRegistrationCards (state, registrationCards) {
    state.scannedDocument = registrationCards.scannedDocument

    if (registrationCards.verifiedDocumentData !== null) {
      state.verifiedDocumentData = registrationCards.verifiedDocumentData
      state.editedVerifiedDocumentData = registrationCards.verifiedDocumentData
    } else {
      let scannedDocumentData = registrationCards.scannedDocument && registrationCards.scannedDocument.scannedDocumentData ? registrationCards.scannedDocument.scannedDocumentData : null
      if (scannedDocumentData) {
        state.editedVerifiedDocumentData = {
          documentType: scannedDocumentData.documentType,
          documentId: scannedDocumentData.documentId,
          name: scannedDocumentData.name,
          lastName: scannedDocumentData.lastName,
          sex: scannedDocumentData.sex,
          address: scannedDocumentData.address,
          dateOfBirth: scannedDocumentData.dateOfBirth,
          dateOfExpiry: scannedDocumentData.dateOfExpiry,
          country: scannedDocumentData.country,
          nationality: scannedDocumentData.nationality || registrationCards.scannedDocument.countryCode.toUpperCase(),
          placeOfBirth: scannedDocumentData.placeOfBirth,
        }
      } else if (registrationCards.scannedDocument !== null) {
        let type = null
        if (registrationCards.scannedDocument.documentFrontImageFileId !== null && registrationCards.scannedDocument.documentBackImageFileId !== null) {
          type = 'ID_CARD'
        } else {
          type = 'PASSPORT'
        }

        state.editedVerifiedDocumentData = {
          documentType: type,
        }
      }
    }

    if (registrationCards.contactData !== null) {
      state.contactData = registrationCards.contactData
    }

    if (registrationCards.tosSignature !== null) {
      state.tosSignature = registrationCards.tosSignature
    }
  },
  setTosFile (state, file) {
    state.tosFile = file
  },
  setEditedVerifiedDocumentDataField (state, { field, value }) {
    if (!state.editedVerifiedDocumentData) {
      state.editedVerifiedDocumentData = {}
    }
    Vue.set(state.editedVerifiedDocumentData, field, value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
